import React from "react";
import { StepperEnum } from "../../../utils/Enums";
import IncubatorHeaderComponent from "../../../components/incubator/common/IncubatorHeaderComponent";
import EacHeaderComponent from "../../eac/common/EacHeaderComponent";


interface IHeaderProps {
  onClick: (index: number) => void;
  errors?: any
  teamError?: Array<Number>;
}

function StepDetailsComponent(props: IHeaderProps) {
  //console.log(props.teamError);
  return (

    <div className="bs-stepper-header" role="tablist" id="step_details" style={{display:'block'}}>
    {/* <IncubatorHeaderComponent /> */}
    <div className="row">
      <div className="col-md-12" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
          <div className="step" data-target="#incubator-step-1">
            <button
              type="button"
              className="step-trigger"
              role="tab"
              id="stepper1trigger1"
              aria-controls="incubator-step-1"
              onClick={() => props.onClick(StepperEnum.GeneralDetail)}
            >
              <span className={props.errors.GeneralDetail.length ? "bs-stepper-circle-error" : "bs-stepper-circle"}></span>

              <span className="bs-stepper-label">General Incubator <br /> Progress</span>
              <div className="bs-stepper-line"></div>
            </button>

        {/* {//console.log(props.team,"generallength")} */}
        
            {
              props.errors.GeneralDetail.length ?
                <span className="badge-red"><i className="fa fa-exclamation-triangle"></i> {props.errors.GeneralDetail.length ? `${props.errors.GeneralDetail.length} invalid fields` : ''}</span>
                : <span />
            }
          </div>
          {/* + props.teamError?.length */}
{/* 

          <div className="step" data-target="#incubator-step-2">
            <button
              type="button"
              className="step-trigger"
              role="tab"
              id="stepper1trigger2"
              aria-controls="incubator-step-2"
              onClick={() => props.onClick(StepperEnum.IncubatorTeam)}
            >
              <span className={props.errors.IncubatorTeam.length || props.teamError?.length ? "bs-stepper-circle-error" : "bs-stepper-circle"}></span>

              <span className="bs-stepper-label">Incubator Scheme Progress - Part 1</span>
              <div className="bs-stepper-line"></div>
            </button>

            {
              props.errors.IncubatorTeam.length || props.teamError?.length ?
                <span className="badge-red"><i className="fa fa-exclamation-triangle"></i> {props.errors.IncubatorTeam.length || props.teamError?.length ? `${props.errors.IncubatorTeam.length } invalid fields` : ''}</span>
                : <span />
            }
            + props.teamError?.length
          </div> */}

          {/* <div className="step" data-target="#incubator-step-3">
            <button
              type="button"
              className="step-trigger"
              role="tab"
              id="stepper1trigger3"
              aria-controls="incubator-step-3"
              onClick={() => props.onClick(StepperEnum.IncubatorDetail)}
            >
              <span className={props.errors.IncubatorDetails.length ? "bs-stepper-circle-error" : "bs-stepper-circle"}></span>

              <span className="bs-stepper-label">Incubator Scheme Progress - Part 2</span>
              <div className="bs-stepper-line"></div>
            </button>


            {
              props.errors.IncubatorDetails.length ?
                <span className="badge-red"><i className="fa fa-exclamation-triangle"></i> {props.errors.IncubatorDetails.length ? `${props.errors.IncubatorDetails.length} invalid fields` : ''}</span>
                : <span />
            }
          </div> */}

          <div className="step" data-target="#incubator-step-4">
            <button
              type="button"
              className="step-trigger"
              role="tab"
              id="stepper1trigger4"
              aria-controls="incubator-step-4"
              onClick={() => props.onClick(StepperEnum.FundUtilization)}
            >
              <span className={props.errors.FundDetails.length ? "bs-stepper-circle-error" : "bs-stepper-circle"}></span>

              <span className="bs-stepper-label">Fund Requirements <br /> Details</span>
            </button>

          {/* {//console.log(props.errors.FundDetails,"fundlengthh")} */}
            {
              props.errors.FundDetails.length ?
                <span className="badge-red"><i className="fa fa-exclamation-triangle"></i> {props.errors.FundDetails.length ? `${props.errors.FundDetails.length} invalid fields` : ''}</span>
                : <span />
            }
          </div>

          {/* <div className="step" data-target="#incubator-step-4">
            <button
              type="button"
              className="step-trigger"
              role="tab"
              id="stepper1trigger4"
              aria-controls="incubator-step-4"
              onClick={() => props.onClick(StepperEnum.FundUtilization)}
            >
              <span className={props.errors.IncubatorDetails.length ? "bs-stepper-circle-error" : "bs-stepper-circle"}></span>

              <span className="bs-stepper-label">Fund Requirements Details</span>
              <div className="bs-stepper-line"></div>
              
            </button>


            {
              props.errors.IncubatorDetails.length ?
                <span className="badge-red"><i className="fa fa-exclamation-triangle"></i> {props.errors.IncubatorDetails.length ? `${props.errors.IncubatorDetails.length} invalid fields` : ''}</span>
                : <span />
            }
          </div> */}
      </div>
    </div>
      

      {/* <div className="step" >
        <button
          type="button"
          className="step-trigger"
          role="tab"
          aria-controls="incubator-step-4"
        ></button>


        {
          props.errors.FundDetails.length ?
            <span className="badge-red"><i className="fa fa-exclamation-triangle"></i> {props.errors.FundDetails.length ? `${props.errors.FundDetails.length} invalid fields` : ''}</span>
            : <span />
        }
      </div> */}

      {/* <div className="step" >
        <button
          type="button"
          className="step-trigger"
          role="tab1"
          aria-controls="incubator-step-5"
        ></button>


      </div> */}
    </div >
  );
}

export default StepDetailsComponent;
